module.exports = __webpack_public_path__ + "static/media/empty-state-maintenance.5fff788d.svg";